import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { BriefingGenerationStatus } from "api/briefingApi.slice";
import type { BriefingGenerationJob } from "domains/briefing/types";

type BriefingGenerationState = {
  briefings: {
    byId: Record<string, BriefingGenerationJob>;
  };
};

const initialState: BriefingGenerationState = {
  briefings: {
    byId: {},
  },
};

export const briefingGenerationSlice = createSlice({
  initialState,
  name: "briefingGeneration",
  reducers: {
    addBriefing: (state, action: PayloadAction<BriefingGenerationJob>) => {
      const { id, status, progress, downloadUrl, topicId } = action.payload;
      state.briefings.byId[id] = {
        id,
        status,
        progress,
        downloadUrl,
        topicId,
      };
    },
    removeBriefing: (state, action: PayloadAction<string>) => {
      const id = action.payload;

      const { [id]: _removedBriefing, ...remainingBriefings } = state.briefings.byId;

      state.briefings.byId = remainingBriefings;
    },
    updateBriefingJobProgress: (state, action: PayloadAction<{ id: string; progress: number }>) => {
      const { id, progress } = action.payload;
      const briefing = state.briefings.byId[id];

      if (briefing) briefing.progress = progress;
    },
    updateBriefingJobDownloadUrl: (state, action: PayloadAction<{ id: string; downloadUrl: string }>) => {
      const { id, downloadUrl } = action.payload;
      const briefing = state.briefings.byId[id];

      if (briefing) briefing.downloadUrl = downloadUrl;
    },
    updateBriefingJobStatus: (state, action: PayloadAction<{ id: string; status: BriefingGenerationStatus }>) => {
      const { id, status } = action.payload;
      const briefing = state.briefings.byId[id];

      if (briefing) briefing.status = status;
    },
  },
});
